import { render, staticRenderFns } from "./Surname.vue?vue&type=template&id=1635ab1d"
import script from "./Surname.vue?vue&type=script&lang=js"
export * from "./Surname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports